// ABOUTME: Agent runs with their steps (REST /agent-runs), which a thread shows as each run's
// activity row. Shapes mirror app/api/v1/agent_runs.py (snake_case, no mapping layer).
import { api } from '@/api/client'

export type RunStepStatus = 'running' | 'done' | 'failed'

export interface AgentRunStep {
  title: string
  subject: string | null
  /** "thinking" for the agent's reasoning between tool calls; null for a tool call. */
  kind: string | null
  text: string | null
  input: string | null
  output: string | null
  status: RunStepStatus
  brief_id: string | null
  started_at: string | null
  ended_at: string | null
}

export interface AgentRun {
  id: string
  /** The team member the run was for (a producer); null for the Marketing agent. */
  agent_role_id: string | null
  status: string
  trigger: string
  channel: string | null
  error: string | null
  started_at: string
  completed_at: string | null
  steps: AgentRunStep[]
  /** The thread messages the run answered. */
  message_ids: string[]
}

export const AGENT_RUN_ACTIVITY_KEY = 'agent-run-activity'

/** The newest runs of one team member (a producer), or every run in one status. */
export async function listRuns(
  filter: { roleId?: string; status?: string },
  limit = 50
): Promise<AgentRun[]> {
  return api.get<AgentRun[]>('/agent-runs', {
    params: { role_id: filter.roleId, status: filter.status, limit },
  })
}

/** The newest runs of one channel (`in_app`: the Marketing thread's). */
export async function listChannelRuns(channel: string, limit = 50): Promise<AgentRun[]> {
  return api.get<AgentRun[]>('/agent-runs', {
    params: { channel, limit },
  })
}
